@let currentError = displayedError;
<div class="input-group">
  <label [for]="controlId">
    {{ label }}
    <span *ngIf="required" aria-hidden="true">*</span>
  </label>
  <input
    [id]="controlId"
    [type]="type"
    [attr.maxlength]="maxLength"
    [formControl]="control"
    [appAutofocus]="autofocus"
    [attr.aria-required]="required"
    [attr.aria-invalid]="currentError ? true : null"
    [attr.aria-describedby]="hint || currentError ? controlId + '-description' : null"
  >
  <div *ngIf="hint || currentError" [id]="controlId + '-description'">
    <p *ngIf="hint" class="field-hint">{{ hint }}</p>
    <p *ngIf="currentError" class="field-error" role="alert">{{ currentError }}</p>
  </div>
</div>
